import React from 'react';
import Moment from 'react-moment';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { StatusFaturamentoEnum } from '../../enums';
import IconeStatusFaturamento from '../IconeStatusFaturamento';

import {
    GetApp as GetAppIcon,
    FileCopy as FileCopyIcon
} from '@material-ui/icons';

import {
    makeStyles,
    Grid,
    Card,
    CardContent,
    Button,
    Typography,
    Chip,
    Divider
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    textTransform: {
        textTransform: 'inherit'
    },
    disabled: {
        color: theme.palette.text.disabled
    },
    primary: {
        color: theme.palette.text.primary
    },
    secondary: {
        color: theme.palette.text.secondary
    },
    status_1: {
        backgroundColor: theme.palette.success.main
    },
    status_2: {
        backgroundColor: theme.palette.error.main
    },
    status_3: {
        backgroundColor: theme.palette.warning.main
    },
    borderLeft:{
        borderLeftWidth: theme.spacing(1),
        borderLeftStyle: 'solid'
    },
    border_1: {
        borderLeftColor: theme.palette.success.main
    },
    border_2: {
        borderLeftColor: theme.palette.error.main
    },
    border_3: {
        borderLeftColor: theme.palette.warning.main
    },
    gridOrigem: {
        marginTop: theme.spacing(1)
    },
    gridValor: {
        marginTop: theme.spacing(2)
    },
    gridStatus: {
        marginTop: theme.spacing(2)
    },
    gridVencimento: {
        marginTop: theme.spacing(2)
    },
    gridBaixarFatura: {
        marginTop: theme.spacing(2)
    },
    gridDivider: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2)
    },
    icon: {
        color: theme.palette.primary[200]
    }
}));

function CardFatura(
    {
        fatura,
        handleBaixarFatura,
        handleCopiarCodigoBarras
    }
) {
    const classes = useStyles();

    return (
        <Card className={`${classes.borderLeft} ${classes[`border_${fatura.codigoSituacao}`]}`}>
            <CardContent>
                <Grid container>
                    <Grid item
                        xs={12}>
                        <Typography variant='overline'
                            className={classes.disabled}>
                            {fatura.identificador}
                        </Typography>
                    </Grid>
                    <Grid item
                        className={classes.gridOrigem}
                        xs={12}>
                        <Typography variant='body2'
                            className={classes.primary}>
                            {fatura.origem}
                        </Typography>
                    </Grid>
                    <Grid item
                        xs={6}>
                        <Grid item
                            container
                            direction='column'>
                            <Grid item
                                className={classes.gridValor}
                                xs={12}>
                                <Typography variant='h5'
                                    color='primary'>
                                    {fatura.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                </Typography>
                            </Grid>
                            <Grid item
                                className={classes.gridVencimento}
                                xs={12}>
                                <Typography variant='subtitle2'
                                    className={classes.disabled}>
                                    Vencimento
                                </Typography>
                            </Grid>
                            <Grid item
                                xs={12}>
                                <Typography variant='body2'
                                    className={classes.secondary}>
                                    <Moment utc={0}
                                        format="DD/MM/YYYY">
                                        {fatura.vencimento}
                                    </Moment>
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item
                        xs={6}>
                        <Grid item
                            container
                            alignContent='flex-end'
                            direction='column'>
                            <Grid item
                                className={classes.gridStatus}
                                xs={12}>
                                <Chip size="small"
                                    className={`${classes[`status_${fatura.codigoSituacao}`]}`}
                                    icon={<IconeStatusFaturamento codigoStatus={fatura.codigoSituacao} />}
                                    label={fatura.descricaoSituacao}
                                    color="primary" />
                            </Grid>
                            <Grid item
                                className={classes.gridBaixarFatura}
                                xs={12}>
                                <Button size='small'
                                    className={classes.textTransform}
                                    startIcon={<GetAppIcon className={classes.icon} />}
                                    onClick={() => handleBaixarFatura(fatura.chaveArquivo)}>
                                    <Typography variant='body2'
                                        className={classes.secondary}>
                                        Baixar fatura
                                    </Typography>
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                    {
                        fatura.linhaDigitavel &&
                        fatura.codigoSituacao !== StatusFaturamentoEnum.PAGO &&
                        <>
                            <Grid item
                                className={classes.gridDivider}
                                xs={12}>
                                <Divider />
                            </Grid>
                            <Grid item
                                xs={12}>
                                <Grid item
                                    container
                                    spacing={1}
                                    justify='center'
                                    alignItems='center'
                                    direction='column'>
                                    <Grid item
                                        xs={12}>
                                        <CopyToClipboard
                                            text={fatura.linhaDigitavel}
                                            onCopy={handleCopiarCodigoBarras}>
                                            <Button className={classes.textTransform}
                                                startIcon={<FileCopyIcon className={classes.icon} />}>
                                                <Typography variant='body2'
                                                    className={classes.secondary}>
                                                    Copiar código de barras
                                                </Typography>
                                            </Button>
                                        </CopyToClipboard>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </>
                    }
                </Grid>
            </CardContent>
        </Card>
    );
}

export default CardFatura;